import React from "react";
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import SidebarCard from "./components/SidebarCard";
import routes from "routes.js";
import { BUSINESS_NAME } from "config.js";

const Sidebar = ({ open, onClose }) => {
    return (
        <>
            {/* 1. DIŞARIYA TIKLAYINCA KAPANMA VE BUĞULU EKRAN (Sadece Mobilde) */}
            <div
                className={`fixed inset-0 z-[45] bg-navy-900/20 backdrop-blur-sm transition-opacity duration-300 xl:hidden ${
                    open ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"
                }`}
                onClick={onClose}
            />

            {/* 2. ANA SIDEBAR YAPISI */}
            <div
                className={`fixed z-[50] flex flex-col bg-white dark:bg-navy-800 transition-transform duration-300 overflow-hidden
          /* MOBİL: FLOATING (YÜZEN) PILL TASARIMI */
          top-4 left-4 h-[calc(100vh-32px)] w-[280px] rounded-[30px] shadow-2xl shadow-navy-900/20
          ${open ? "translate-x-0" : "-translate-x-[120%]"}
          
          /* MASAÜSTÜ (XL): SOLA SABİT YAPI */
          xl:top-0 xl:left-0 xl:h-screen xl:w-[280px] xl:translate-x-0 xl:rounded-none xl:border-r xl:border-gray-100 xl:shadow-none xl:dark:border-white/10
        `}
            >

                {/* --- ÜST KISIM (LOGO) : SABİT (flex-none) --- */}
                <div className="flex-none pt-8 pb-4 px-8 relative flex flex-col items-center">
                    {/* Mobil Kapatma Butonu */}
                    <span
                        className="absolute top-4 right-4 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-white/10 xl:hidden transition-colors"
                        onClick={onClose}
                    >
                        <HiX className="h-5 w-5 text-navy-700 dark:text-white" />
                    </span>

                    <div className="font-poppins text-[26px] font-bold text-brand-500 dark:text-white tracking-tight text-center w-full">
                        {BUSINESS_NAME || "RandevUpp"}
                    </div>
                    <div className="mt-6 h-px w-full bg-gray-100 dark:bg-white/10" />
                </div>

                {/* --- ORTA KISIM (LİNKLER) : KAYDIRILABİLİR (flex-1 overflow-y-auto) --- */}
                <div className="flex-1 overflow-y-auto custom-sidebar-scroll px-4">
                    <ul className="mb-auto pt-1 pb-4">
                        <Links routes={routes} />
                    </ul>
                </div>

                {/* --- ALT KISIM (SAAT/KART) : SABİT (flex-none) --- */}
                <div className="flex-none p-6 border-t border-gray-50 dark:border-white/5 bg-white dark:bg-navy-800">
                    <SidebarCard />
                </div>

                {/* Scrollbar'ı Çirkinlikten Kurtaran CSS */}
                <style jsx>{`
                  .custom-sidebar-scroll::-webkit-scrollbar {
                    width: 4px;
                  }
                  .custom-sidebar-scroll::-webkit-scrollbar-track {
                    background: transparent;
                  }
                  .custom-sidebar-scroll::-webkit-scrollbar-thumb {
                    background: rgba(163, 174, 208, 0.3);
                    border-radius: 10px;
                  }
                  .dark .custom-sidebar-scroll::-webkit-scrollbar-thumb {
                    background: rgba(255, 255, 255, 0.1);
                  }
                `}</style>
            </div>
        </>
    );
};

export default Sidebar;